import * as React from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { pathContains } from "../../helpers";
import { setPresentRoute } from "../../stateManagement/reducers/routesReducer";

interface IProps {
  title: string;
  navItems: any[];
  url: string;
  baseUri: string;

  callback?: () => any;
}

const MouseOverPopOverMobile2: React.FC<IProps> = ({
  title,
  navItems,
  url,
  baseUri,
  callback,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const [selectedIndex, setSelectedIndex] = React.useState<number | null>(null);
  const location = useLocation();
  const [presentPage, setPresentPage] = React.useState("");
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (index: number) => {
    setSelectedIndex(index);
    // You can add additional logic for what should happen when the item is clicked

    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div
      className="relative w-full flex flex-col items-start justify-start"
      onMouseLeave={handlePopoverClose}
    >
      <button
        className={`py-[.75rem] text-white block hover:bg-transparent ${
          pathContains(location.pathname, baseUri) || open
            ? "text-primary"
            : "text-black"
        } `}
        onMouseEnter={handlePopoverOpen}
        onClick={() => {
          if (navItems.length === 0) {
            setPresentPage(url);
            dispatch(setPresentRoute(url));
            navigate(url, { replace: true });
            if (callback) callback();
          }
        }}
        style={{
          borderBottom: "solid 1px #e3e3de99",
          width: "100%",
          textAlign: "left",
        }}
      >
        <span
          className={`  ${
            pathContains(location.pathname, baseUri)
              ? "text-primary"
              : "text-black"
          } hover:text-[rgba(26,189,84,1)] whitespace-nowrap`}
        >
          {title.toUpperCase()}
        </span>
      </button>
      {navItems.length > 0 && open && (
        <div className="w-full flex justify-center  z-[10000000000000] left-0 top-11 mt-0">
          <div
            className=" w-fit  bg-[rgba(5,35,16,1)] rounded-b-2xl"
            onMouseLeave={handlePopoverClose}
          >
            <div className="flex flex-col items-start w-full">
              {navItems.map((navItem, i) => {
                return (
                  <button
                    key={i}
                    className={`w-full text-left p-3 ${
                      i !== 0 ? "border-t border-white" : ""
                    } ${
                      pathContains(location.pathname, navItem.id)
                        ? "text-[rgba(26,189,84,1)]"
                        : "text-white"
                    } hover:text-[rgba(26,189,84,1)]`}
                    onClick={() => {
                      handleMenuItemClick(i);
                      setPresentPage(navItem.url);
                      dispatch(setPresentRoute(navItem.url));
                      navigate(navItem.url, { replace: true });
                      if (callback) callback();
                    }}
                  >
                    <span className="md:text-base whitespace-nowrap">
                      {navItem.title.toUpperCase()}
                    </span>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MouseOverPopOverMobile2;
